/**
 * Extract a human-friendly error string from an axios error object.
 * Handles plain-string `detail` (FastAPI HTTPException), the validation-errors
 * list FastAPI emits for Pydantic failures, and slowapi's rate-limit
 * `error` payload returned with HTTP 429.
 */
export function apiErrorMessage(err, fallback = "Something went wrong") {
  // slowapi: { error: "Rate limit exceeded: 5 per 1 hour" } @ 429
  if (err?.response?.status === 429) {
    return "Too many attempts — please wait a few minutes and try again.";
  }
  const data = err?.response?.data;
  const detail = data?.detail ?? data?.error;
  if (!detail) {
    return err?.message || fallback;
  }
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    // Pydantic validation list — show the first actionable message.
    const first = detail[0];
    if (first?.msg) {
      const field = Array.isArray(first.loc) ? first.loc.slice(-1)[0] : "";
      return field ? `${field}: ${first.msg}` : first.msg;
    }
  }
  if (typeof detail === "object" && detail?.msg) return detail.msg;
  return fallback;
}
